
import Vue from "vue";
import { UblDossierConfig } from "@/plugins/ubl/models/ubl-dossier-config";
import { EmailAttachmentConfig } from "@/plugins/ubl/models/email-attachment-config";
import { ISelectItem } from "winfakt-vue-components";
import { AuthService, DossierService, UserConfigService } from "@/services";
import { MODULE } from "@/config/modules";
import { AutoSendToBookkeeperSettings } from "@/models/dossier/auto-send-to-bookkeeper-settings";

export default Vue.extend({
	data(){
		return {
			autoSendToBookkeeperSettings: new AutoSendToBookkeeperSettings()
		};
	},
	props: {
		config: {
			type: Object as () => UblDossierConfig,
			required: true,
		}
	},
	computed: {
		showAutoSendToBookkeeperSettings():boolean {
			if (AuthService.wfCompany.OwnerID != AuthService.wfUser.ID && !UserConfigService.getPermissionSettings().IsAdmin){
				return false;
			}
			if (!AuthService.hasModule(MODULE.EXPORT_NAAR_EXTERN_BOEKHPAKKET)) {
				return false;
			}
			return true;
		},
		saleOptions():ISelectItem<string>[] {
			return [
				{
					value: "pdf",
					text: "PDF"
				},
				{
					value: "ubl",
					text: "UBL",
					disabled: this.bookkeeperAttachmentsSales.indexOf("peppol") != -1 && this.bookkeeperAttachmentsSales.indexOf("ubl") == -1
				},
				{
					value: "peppol",
					text: "PEPPOL",
					disabled: this.bookkeeperAttachmentsSales.indexOf("ubl") != -1 && this.bookkeeperAttachmentsSales.indexOf("peppol") == -1
				},
			];
		},
		purchaseOptions():ISelectItem<string>[] {
			return [
				{
					value: "pdf",
					text: "PDF"
				},
				{
					value: "ubl",
					text: "UBL",
					disabled: this.bookkeeperAttachmentsPurchases.indexOf("peppol") != -1 && this.bookkeeperAttachmentsPurchases.indexOf("ubl") == -1},
				{
					value: "peppol",
					text: "PEPPOL",
					disabled: this.bookkeeperAttachmentsPurchases.indexOf("ubl") != -1 && this.bookkeeperAttachmentsPurchases.indexOf("peppol") == -1
				},
			];
		},
		incommingPeppolOrderOptions():ISelectItem<string>[] {
			return [
				{
					value: "approved",
					text: "Goedgekeurde documenten",
				},
				{
					value: "not-approved",
					text: "Niet goedgekeurde documenten",
				},
			];
		},
		bookkeeperEmailSales: {
			get(): string {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs.sales) {
					return this.config.BookkeeperEmailConfigs.sales.Email;
				}
				return this.config.BookkeeperEmail || "";
			},
			set(value: string) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs.sales) {
					this.config.BookkeeperEmailConfigs.sales = new EmailAttachmentConfig();
				}
				this.config.BookkeeperEmailConfigs.sales.Email = value;
			}
		},
		bookkeeperEmailPurchases: {
			get(): string {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs.purchases) {
					return this.config.BookkeeperEmailConfigs.purchases.Email;
				}
				return this.config.BookkeeperEmailPurchases || "";
			},
			set(value: string) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs.purchases) {
					this.config.BookkeeperEmailConfigs.purchases = new EmailAttachmentConfig();
				}
				this.config.BookkeeperEmailConfigs.purchases.Email = value;
			}
		},
		bookkeeperAttachmentsSales: {
			get(): string[] {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs.sales) {
					return this.config.BookkeeperEmailConfigs.sales.Attachments || [];
				}
				return [];
			},
			set(value: string[]) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs.sales) {
					this.config.BookkeeperEmailConfigs.sales = new EmailAttachmentConfig();
				}
				this.config.BookkeeperEmailConfigs.sales.Attachments = value;
			}
		},
		bookkeeperAttachmentsPurchases: {
			get(): string[] {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs.purchases) {
					return this.config.BookkeeperEmailConfigs.purchases.Attachments || [];
				}
				return [];
			},
			set(value: string[]) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs.purchases) {
					this.config.BookkeeperEmailConfigs.purchases = new EmailAttachmentConfig();
				}
				this.config.BookkeeperEmailConfigs.purchases.Attachments = value;
			}
		},
		bookkeeperAttachmentsIncommingPeppolOrders: {
			get(): string[] {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs["incomming-peppol-orders"]) {
					return this.config.BookkeeperEmailConfigs["incomming-peppol-orders"].Attachments || [];
				}
				return [];
			},
			set(value: string[]) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs["incomming-peppol-orders"]) {
					this.$set(this.config.BookkeeperEmailConfigs, "incomming-peppol-orders", new EmailAttachmentConfig());
				}
				this.config.BookkeeperEmailConfigs["incomming-peppol-orders"].Attachments = value;
			}
		},
		bookkeeperEmailIncommingPeppolOrders: {
			get(): string {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs["incomming-peppol-orders"]) {
					return this.config.BookkeeperEmailConfigs["incomming-peppol-orders"].Email;
				}
				return this.config.BookkeeperEmailPurchases || "";
			},
			set(value: string) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs["incomming-peppol-orders"]) {
					this.$set(this.config.BookkeeperEmailConfigs, "incomming-peppol-orders", new EmailAttachmentConfig());
				}
				this.config.BookkeeperEmailConfigs["incomming-peppol-orders"].Email = value;
			}
		},
		bookkeeperAttachmentsIncommingEmailDocuments: {
			get(): string[] {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs["incomming-email-documents"]) {
					return this.config.BookkeeperEmailConfigs["incomming-email-documents"].Attachments || [];
				}
				return [];
			},
			set(value: string[]) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs["incomming-email-documents"]) {
					this.$set(this.config.BookkeeperEmailConfigs, "incomming-email-documents", new EmailAttachmentConfig());
				}
				this.config.BookkeeperEmailConfigs["incomming-email-documents"].Attachments = value;
			}
		},
		bookkeeperEmailIncommingEmailDocuments: {
			get(): string {
				if (this.config.BookkeeperEmailConfigs && this.config.BookkeeperEmailConfigs["incomming-email-documents"]) {
					return this.config.BookkeeperEmailConfigs["incomming-email-documents"].Email;
				}
				return "";
			},
			set(value: string) {
				if (!this.config.BookkeeperEmailConfigs) {
					this.config.BookkeeperEmailConfigs = {};
				}
				if (!this.config.BookkeeperEmailConfigs["incomming-email-documents"]) {
					this.$set(this.config.BookkeeperEmailConfigs, "incomming-email-documents", new EmailAttachmentConfig());
				}
				this.config.BookkeeperEmailConfigs["incomming-email-documents"].Email = value;
			}
		},
	},
	methods: {
		async save(){
			this.$emit("save-config");
			let targetConfig = await this.autoSendToBookkeeperSettings;
			await this.fetchAutoSendToBookkeperSettings();
			if (this.autoSendToBookkeeperSettings.SendSales != targetConfig.SendSales){
				await this.setAutoSendToBookkeeperSettingsSalesEnabled(targetConfig.SendSales);
			}
			if (this.autoSendToBookkeeperSettings.SendPurchases != targetConfig.SendPurchases){
				await this.setAutoSendToBookkeeperSettingsPurchasesEnabled(targetConfig.SendPurchases);
			}
			if (this.autoSendToBookkeeperSettings.SendIncommingPeppolOrders != targetConfig.SendIncommingPeppolOrders ||
				this.autoSendToBookkeeperSettings.SendIncommingPeppolOrdersFromDate != targetConfig.SendIncommingPeppolOrdersFromDate) {
				await this.setAutoSendToBookkeeperSettingIncommingPeppolOrdersEnabled(targetConfig.SendIncommingPeppolOrders, targetConfig.SendIncommingPeppolOrdersFromDate);
			}
			if (this.autoSendToBookkeeperSettings.SendIncommingEmailDocuments != targetConfig.SendIncommingEmailDocuments ||
				this.autoSendToBookkeeperSettings.SendIncommingEmailDocumentsFromDate != targetConfig.SendIncommingEmailDocumentsFromDate) {
				await this.setAutoSendToBookkeeperSettingIncommingEmailDocumentsEnabled(targetConfig.SendIncommingEmailDocuments, targetConfig.SendIncommingEmailDocumentsFromDate);
			}
		},
		async fetchAutoSendToBookkeperSettings(){
			if (!this.showAutoSendToBookkeeperSettings) return;
			this.autoSendToBookkeeperSettings = await DossierService.getAutoSendToBookkeeperSettings();
		},
		async setAutoSendToBookkeeperSettingsSalesEnabled(enabled:boolean){
			if (!this.showAutoSendToBookkeeperSettings) return;
			this.autoSendToBookkeeperSettings = await DossierService.setAutoSendToBookkeeperSettingsSalesEnabled(enabled);
		},
		async setAutoSendToBookkeeperSettingsPurchasesEnabled(enabled:boolean){
			if (!this.showAutoSendToBookkeeperSettings) return;
			this.autoSendToBookkeeperSettings = await DossierService.setAutoSendToBookkeeperSettingsPurchasesEnabled(enabled);
		},
		async setAutoSendToBookkeeperSettingIncommingPeppolOrdersEnabled(enabled:boolean, fromDate:Date | null){
			if (!this.showAutoSendToBookkeeperSettings) return;
			this.autoSendToBookkeeperSettings = await DossierService.setAutoSendToBookkeeperSettingIncommingPeppolOrdersEnabled(enabled, fromDate);
		},
		async setAutoSendToBookkeeperSettingIncommingEmailDocumentsEnabled(enabled:boolean, fromDate:Date | null){
			if (!this.showAutoSendToBookkeeperSettings) return;
			this.autoSendToBookkeeperSettings = await DossierService.setAutoSendToBookkeeperSettingIncommingEmailDocumentsEnabled(enabled, fromDate);
		}
	},
	async created(){
		if (!this.config.BookkeeperEmailConfigs) {
			this.$set(this.config, "BookkeeperEmailConfigs", {});
		}
		if (!this.config.BookkeeperEmailConfigs.sales) {
			this.$set(this.config.BookkeeperEmailConfigs, "sales", new EmailAttachmentConfig());
		}
		if (!this.config.BookkeeperEmailConfigs.purchases) {
			this.$set(this.config.BookkeeperEmailConfigs, "purchases", new EmailAttachmentConfig());
		}
		if (!this.config.BookkeeperEmailConfigs["incomming-peppol-orders"]) {
			this.$set(this.config.BookkeeperEmailConfigs, "incomming-peppol-orders", new EmailAttachmentConfig());
		}
		if (!this.config.BookkeeperEmailConfigs["incomming-email-documents"]) {
			this.$set(this.config.BookkeeperEmailConfigs, "incomming-email-documents", new EmailAttachmentConfig());
		}
		await this.fetchAutoSendToBookkeperSettings();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
